// extracted by mini-css-extract-plugin
export var activeFilterButton = "_n7-c";
export var backButton = "_n7-4";
export var backIcon = "_n7-5";
export var chevronShortcut = "_n7-6";
export var container = "_n7-1";
export var editor = "_n7-8";
export var editorWrapper = "_n7-7";
export var prefix = "_n7-2";
export var searchIcon = "_n7-3";
export var suffix = "_n7-9";
export var suffixContent = "_n7-a";
export var suffixText = "_n7-b";
export var wrapper = "_n7-0";